import queryString from "query-string";
import {
  DEFAULT_IMPREST_FILTER_STATES,
  IMPREST_STATES,
  TEAM_IDS,
  USER_IDS
} from "../../../../constants/filters";
import {
  GetIdsList,
  GetImprestStateList
} from "../../../../assets/convertUrlFilter";

export const GetFilter = () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  return {
    [IMPREST_STATES]: GetImprestStateList(
      filters[IMPREST_STATES],
      DEFAULT_IMPREST_FILTER_STATES
    ),
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: GetIdsList(filters[TEAM_IDS])
  };
};
